import { useEffect, useState } from 'react'
import { showQuickLink } from './quicklink'
import { stopVideosPlaying } from './utils'
import YouTube from 'react-youtube'
import Markdown from 'react-markdown'
import AscButtons from './AscButtons'
import { emptyMessage } from '../plugins/rasaPlugin'
import axios from 'axios'
import { axiosConfig } from '../plugins/utils/ascUtils'

const pluginButtonType = {
    asc_plugin: AscButtons,
    cover_page_plugin: false,
}

export default function BotResponse({ sender_id, message, dataSet, send, isExpanded, mainSizing, currentPlugin, setSourceInfo, sourceInfo, isLast }) {
    const [readMoreHidden, setReadMoreHidden] = useState(true)

    const [displayText, setDisplayText] = useState('')
    const [readMoreText, setReadMoreText] = useState('')

    const { width, bot_bg_color, bot_text_color, bot_hyperlink_color, read_more_text_color, buttons_bg_color, buttons_text_color } = dataSet

    let text = ''
    if (message.message) text = message.message

    if (!message.message && !message.image && !message.video) {
        text = emptyMessage
    }

    if (!message.message && !message.image && !message.video) {
        text = '[the response from the chatbot has no message]'
    }

    async function handleLogClick(linkType, linkText) {
        const jsonBodyData = {
            message: `${linkType} | ${linkText}`,
            payload: message.payload,
            sender: sender_id,
            msg_type: 'log_click',
        }
        const response = await axios.post(`https://asc-saas-action-server-prod.azurewebsites.net/webhook`, jsonBodyData, axiosConfig)
    }

    useEffect(() => {
        if (document.getElementById('linkText')) {
            document.getElementById('linkText').addEventListener('click', () => {
                handleLogClick('textlink', document.getElementById('linkText').getAttribute('href'))
            })
        }
    }, [])

    useEffect(() => {
        if (text.includes('$$$')) {
            setDisplayText(text.split('$$$')[0])
            setReadMoreText(text.split('$$$')[1])
        }
    }, [])

    const [buttons, setButtons] = useState(message.buttons ?? [])
    const img = message.image
    const video = message.video
    let videoId = ''
    if (video) {
        const videoUrl = message.video.split('/')
        videoId = videoId + videoUrl[videoUrl.length - 1]
    }
    const quicklink = message.quicklink

    useEffect(() => {
        if (message?.custom?.keyword === 'letterfill' && isLast) {
            setButtons(message.buttons)
        }
    }, [message])

    const toggleReadMore = () => {
        setReadMoreHidden(!readMoreHidden)
        handleLogClick('readMore', readMoreHidden ? 'opened' : 'closed')
    }

    const sendPayload = button => {
        stopVideosPlaying()
        // not using hideButtons state as this isn't easily accessible within input.js
        setButtons([])
        if (
            message.custom.keyword &&
            (message.custom.keyword.startsWith('equalities') ||
                message.custom.keyword.startsWith('ethnicity') ||
                message.custom.keyword.startsWith('armedservices'))
        ) {
            send(button.text, button.payload, { msg_type: message.custom.keyword })
        }
        send(button.text, button.payload, { msg_type: button.msgType })
    }

    const ButtonPlugin = pluginButtonType[currentPlugin]

    let buttonLayout = {}
    if (buttons.length > 3 && buttons[0].img) {
        buttonLayout = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
        }
    } else {
        buttonLayout = {
            width: Number(width.replace('px', '')) - 50,
            height: 'auto',
            flexWrap: 'wrap',
        }
    }

    const customMaxWidth = mainSizing.width === 'calc(100% - 10px)' ? '100vw' : mainSizing.width

    return (
        <div>
            <div className='flexR'>
                <div
                    className='line bot flexC'
                    style={{
                        backgroundColor: bot_bg_color,
                        color: bot_text_color,
                        maxWidth: `calc(${customMaxWidth} - 150px)`,
                        wordBreak: 'break-word',
                    }}
                >
                    {img && (
                        <img
                            src={img}
                            alt='an image'
                            className='responseImage'
                            style={{
                                maxWidth: '95%',
                                height: 'auto',
                                padding: '0 5px 5px 5px',
                            }}
                        />
                    )}
                    {video && (
                        <YouTube
                            opts={{
                                width: `${isExpanded} ? '500px' : 'auto'`,
                                height: `${isExpanded} ? '270px' : 'auto'`,
                                playerVars: {
                                    // https://developers.google.com/youtube/player_parameters
                                },
                            }}
                            videoId={videoId}
                            onPlay={e => handleLogClick('video_play', video)}
                            onPause={e => handleLogClick('video_pause', video)}
                        />
                    )}
                    {message.message && !video && (
                        <div>
                            <Markdown
                                components={{
                                    p(props) {
                                        const { node, ...rest } = props
                                        return (
                                            <p
                                                style={{ padding: 0, margin: 0 }}
                                                {...rest}
                                            />
                                        )
                                    },
                                    hr: 'br',
                                    a(props) {
                                        const { node, ...rest } = props
                                        return (
                                            <a
                                                style={{
                                                    color: bot_hyperlink_color,
                                                    textDecoration: 'underline',
                                                }}
                                                id='linkText'
                                                target='_blank'
                                                {...rest}
                                            />
                                        )
                                    },
                                }}
                            >
                                {displayText !== '' ? displayText : text}
                            </Markdown>
                            {readMoreText && (
                                <button
                                    onClick={toggleReadMore}
                                    className={'readMoreButton' + (readMoreHidden ? 'Closed' : 'Open')}
                                    style={{ color: read_more_text_color }}
                                    title='Read more'
                                >
                                    {readMoreHidden ? 'Read more' : 'Read less'}
                                </button>
                            )}
                        </div>
                    )}
                    {!readMoreHidden && (
                        <Markdown
                            components={{
                                p(props) {
                                    const { node, ...rest } = props
                                    return (
                                        <p
                                            style={{ padding: 0, margin: 0 }}
                                            {...rest}
                                        />
                                    )
                                },
                                hr: 'br',
                                a(props) {
                                    const { node, ...rest } = props
                                    return (
                                        <a
                                            style={{
                                                color: bot_hyperlink_color,
                                                textDecoration: 'underline',
                                            }}
                                            id='linkText'
                                            target='_blank'
                                            {...rest}
                                        />
                                    )
                                },
                            }}
                        >
                            {readMoreText}
                        </Markdown>
                    )}
                </div>
                {quicklink && showQuickLink(sender_id, message.payload, quicklink.URL, quicklink.text, dataSet)}
            </div>
            {ButtonPlugin && buttons.length > 0 ? (
                <ButtonPlugin
                    buttons={buttons}
                    dataSet={dataSet}
                    send={send}
                    sendPayload={sendPayload}
                    setButtons={setButtons}
                    mainSizing={mainSizing}
                    isExpanded={isExpanded}
                    customMaxWidth={customMaxWidth}
                />
            ) : (
                <div
                    className='flexR buttonsContainer'
                    style={buttonLayout}
                >
                    {buttons.map((button, index) => (
                        <button
                            key={index}
                            className={'responseButton'}
                            onClick={() => sendPayload(button)}
                            style={{
                                backgroundColor: buttons_bg_color,
                                color: buttons_text_color,
                                maxWidth: '100%',
                            }}
                        >
                            <div>{button.text}</div>
                            {button.img && (
                                <img
                                    src={button.img}
                                    className='buttonImage'
                                    style={{
                                        width: '50%',
                                        height: '60px',
                                        paddingBottom: button.subtext ? '0px' : '10px',
                                    }}
                                />
                            )}
                            {button.subtext && <div className='buttonSubtext'>{button.subtext}</div>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}
